<template>

  <Head title="Aplikasi" />
  <Container>
    <template #header>
      <Header :menu="$page.props.main_menu" v-if="$page.props.auth.user" />
    </template>
    <template #default>
      <div>
        <Breadcrumbs :breadcrumbs="[
          { name: 'Dashboard', href: route('dashboard') },
          { name: 'Aplikasi', href: route('aplikasi.index') },
        ]" />

        <div class="max-w-3xl mx-auto">
          <div class="space-y-6">
            <div class="bg-white border border-gray-200 shadow-lg rounded-xl">
              <div
                class="px-4 py-3 border-b border-gray-200 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-t-xl sm:px-6 sm:py-4">
                <h2 class="flex items-center text-lg font-bold text-white sm:text-xl">
                  <i class="mr-2 fa-solid fa-mobile-screen-button sm:mr-3"></i>
                  Pengaturan Aplikasi
                </h2>
              </div>
              <div class="p-4 sm:p-6">
                <form class="space-y-4" @submit.prevent="submitForm">
                  <!-- Basic App Info -->
                  <div>
                    <label for="namaapps" class="block mb-2 text-sm font-medium text-gray-900">
                      Nama Aplikasi
                    </label>
                    <input v-model="form.namaapps" type="text" id="namaapps"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="Masukkan nama aplikasi" required />
                    <div v-if="form.errors.namaapps" class="mt-1 text-sm text-red-600">
                      {{ form.errors.namaapps }}
                    </div>
                  </div>

                  <div>
                    <label for="url" class="block mb-2 text-sm font-medium text-gray-900">
                      URL Aplikasi
                    </label>
                    <input v-model="form.url" type="url" id="url"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="https://example.com" required />
                    <div v-if="form.errors.url" class="mt-1 text-sm text-red-600">
                      {{ form.errors.url }}
                    </div>
                  </div>

                  <div>
                    <label for="logo" class="block mb-2 text-sm font-medium text-gray-900">
                      Logo Aplikasi
                    </label>
                    <input type="file" id="logo"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200 file:mr-3 file:py-1 file:px-3 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100"
                      @change="onLogoChange" accept="image/*" />
                    <div v-if="form.errors.logo" class="mt-1 text-sm text-red-600">
                      {{ form.errors.logo }}
                    </div>
                    <div v-if="logoPreview" class="mt-3">
                      <img :src="logoPreview" alt="Preview Logo"
                        class="object-cover w-16 h-16 border border-gray-200 rounded-lg shadow-sm" />
                    </div>
                  </div>

                  <div>
                    <label for="deskripsi" class="block mb-2 text-sm font-medium text-gray-900">
                      Deskripsi
                    </label>
                    <textarea v-model="form.deskripsi" id="deskripsi" rows="3"
                      class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                      placeholder="Masukkan deskripsi aplikasi"></textarea>
                    <div v-if="form.errors.deskripsi" class="mt-1 text-sm text-red-600">
                      {{ form.errors.deskripsi }}
                    </div>
                  </div>

                  <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                    <div>
                      <label for="bussinesname" class="block mb-2 text-sm font-medium text-gray-900">
                        Nama Bisnis
                      </label>
                      <input v-model="form.bussinesname" type="text" id="bussinesname"
                        class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                        placeholder="Nama bisnis" />
                      <div v-if="form.errors.bussinesname" class="mt-1 text-sm text-red-600">
                        {{ form.errors.bussinesname }}
                      </div>
                    </div>

                    <div>
                      <label for="version" class="block mb-2 text-sm font-medium text-gray-900">
                        Versi
                      </label>
                      <input v-model="form.version" type="text" id="version"
                        class="block w-full px-3 py-2.5 text-sm text-gray-900 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400 transition-colors duration-200"
                        placeholder="v1.0.0" />
                      <div v-if="form.errors.version" class="mt-1 text-sm text-red-600">
                        {{ form.errors.version }}
                      </div>
                    </div>
                  </div>

                  <!-- Theme Picker Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-1 text-sm font-semibold text-gray-900">
                      🎨 Tema Tampilan (Theme)
                    </h3>
                    <p class="mb-4 text-xs text-gray-500">
                      Warna tema yang digunakan pada tampilan frontend aplikasi.
                    </p>
                    <div class="flex flex-wrap gap-3">
                      <button
                        v-for="t in themes"
                        :key="t.value"
                        type="button"
                        @click="form.theme = t.value"
                        :class="[
                          'flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg border-2 transition-colors duration-200',
                          form.theme === t.value
                            ? 'border-gray-800 bg-white'
                            : 'border-gray-200 bg-white hover:border-gray-400',
                        ]"
                      >
                        <span
                          class="inline-block w-5 h-5 border border-white rounded-full shadow"
                          :style="{ backgroundColor: t.color }"
                        ></span>
                        {{ t.label }}
                        <i
                          v-if="form.theme === t.value"
                          class="text-gray-700 fa-solid fa-check"
                        ></i>
                      </button>
                    </div>
                    <div
                      v-if="form.errors.theme"
                      class="mt-2 text-sm text-red-600"
                    >
                      {{ form.errors.theme }}
                    </div>
                  </div>

                  <!-- Font Picker Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-1 text-sm font-semibold text-gray-900">
                      🔤 Font Tampilan (Font Family)
                    </h3>
                    <p class="mb-4 text-xs text-gray-500">
                      Jenis huruf yang digunakan pada tampilan frontend.
                    </p>
                    <div class="grid grid-cols-2 gap-3 sm:grid-cols-3">
                      <button
                        v-for="f in fonts"
                        :key="f.value"
                        type="button"
                        @click="form.font_family = f.value"
                        :style="{ fontFamily: f.stack }"
                        :class="[
                          'flex items-center justify-between gap-2 px-4 py-3 text-sm rounded-lg border-2 transition-colors duration-200 bg-white',
                          form.font_family === f.value
                            ? 'border-gray-800'
                            : 'border-gray-200 hover:border-gray-400',
                        ]"
                      >
                        <span>{{ f.label }}</span>
                        <i v-if="form.font_family === f.value" class="text-gray-700 fa-solid fa-check"></i>
                      </button>
                    </div>
                    <div v-if="form.errors.font_family" class="mt-2 text-sm text-red-600">
                      {{ form.errors.font_family }}
                    </div>
                  </div>

                  <!-- Social Media Links Section -->
                  <div class="p-4 border border-gray-200 rounded-lg bg-gray-50">
                    <h3 class="mb-4 text-sm font-semibold text-gray-900">
                      🔗 Link Media Sosial
                    </h3>

                    <div class="space-y-3">
                      <div>
                        <label for="linkfb" class="block mb-1 text-sm font-medium text-gray-700">
                          Facebook
                        </label>
                        <input v-model="form.linkfb" type="url" id="linkfb"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://facebook.com/username" />
                      </div>

                      <div>
                        <label for="linkinstagram" class="block mb-1 text-sm font-medium text-gray-700">
                          Instagram
                        </label>
                        <input v-model="form.linkinstagram" type="url" id="linkinstagram"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://instagram.com/username" />
                      </div>

                      <div>
                        <label for="linkyoutube" class="block mb-1 text-sm font-medium text-gray-700">
                          YouTube
                        </label>
                        <input v-model="form.linkyoutube" type="url" id="linkyoutube"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://youtube.com/@username" />
                      </div>

                      <div>
                        <label for="linkemail" class="block mb-1 text-sm font-medium text-gray-700">
                          Email
                        </label>
                        <input v-model="form.linkemail" type="email" id="linkemail"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="info@example.com" />
                      </div>
                      <!-- Link tiktok-->
                      <div>
                        <label for="linktiktok" class="block mb-1 text-sm font-medium text-gray-700">
                          TikTok
                        </label>
                        <input v-model="form.linktiktok" type="url" id="linktiktok"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://tiktok.com/@username" />
                      </div>

                      <div>
                        <label for="linkweb" class="block mb-1 text-sm font-medium text-gray-700">
                          Website
                        </label>
                        <input v-model="form.linkweb" type="url" id="linkweb"
                          class="block w-full px-3 py-2 text-sm text-gray-900 transition-colors duration-200 bg-white border border-gray-300 rounded-lg shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 hover:border-gray-400"
                          placeholder="https://website.com" />
                      </div>
                    </div>
                  </div>

                  <!-- Submit Buttons -->
                  <div class="pt-4 space-y-2">
                    <button type="submit"
                      class="w-full px-4 py-2.5 text-sm font-semibold text-white bg-indigo-600 border border-transparent rounded-lg shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200">
                      <i class="mr-2 fa-solid fa-floppy-disk"></i>
                      Simpan Pengaturan
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </Container>
</template>

<script setup>
import { useForm, usePage, router } from "@inertiajs/vue3";
import { ref } from "vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import Container from "@/Layouts/Container.vue";
import Header from "@/Components/Header.vue";
import Swal from "sweetalert2";

const props = defineProps({
  // Pengaturan aplikasi bersifat tunggal (1 record). Bisa null bila belum ada.
  aplikasi: {
    type: Object,
    default: null,
  },
});

const a = props.aplikasi || {};
const form = useForm({
  id: a.id || null,
  namaapps: a.namaapps || "",
  url: a.url || "",
  logo: null,
  deskripsi: a.deskripsi || "",
  bussinesname: a.bussinesname || "",
  version: a.version || "",
  theme: a.theme || "maroon",
  font_family: a.font_family || "inter",
  linkfb: a.linkfb || "",
  linkinstagram: a.linkinstagram || "",
  linkyoutube: a.linkyoutube || "",
  linkemail: a.linkemail || "",
  linktiktok: a.linktiktok || "",
  linkweb: a.linkweb || "",
});

const themes = [
  { value: "maroon", label: "Maroon", color: "#cc4444" },
  { value: "blue", label: "Blue", color: "#2563eb" },
  { value: "emerald", label: "Emerald", color: "#059669" },
  { value: "violet", label: "Violet", color: "#7c3aed" },
  { value: "teal", label: "Teal", color: "#0d9488" },
  { value: "navy", label: "Biru Tua", color: "#1e3a8a" },
];

const fonts = [
  { value: "inter", label: "Inter", stack: "'Inter', sans-serif" },
  { value: "poppins", label: "Poppins", stack: "'Poppins', sans-serif" },
  { value: "nunito", label: "Nunito", stack: "'Nunito', sans-serif" },
  { value: "montserrat", label: "Montserrat", stack: "'Montserrat', sans-serif" },
  { value: "merriweather", label: "Merriweather", stack: "'Merriweather', serif" },
  { value: "playfair", label: "Playfair", stack: "'Playfair Display', serif" },
  { value: "roboto-slab", label: "Roboto Slab", stack: "'Roboto Slab', serif" },
  { value: "sora", label: "Sora", stack: "'Sora', sans-serif" },
  { value: "jakarta", label: "Plus Jakarta Sans", stack: "'Plus Jakarta Sans', sans-serif" },
  { value: "dm-sans", label: "DM Sans", stack: "'DM Sans', sans-serif" },
];

const logoPreview = ref(a.logo ? `/storage/${a.logo}` : null);

const onLogoChange = (e) => {
  const file = e.target.files[0];
  if (file) {
    form.logo = file;
    logoPreview.value = URL.createObjectURL(file);
  } else {
    form.logo = null;
  }
};

const submitForm = () => {
  // Pengaturan tunggal: perbarui bila sudah ada, selain itu buat baru.
  if (form.id) {
    const formData = new FormData();
    formData.append("namaapps", form.namaapps || "");
    formData.append("url", form.url || "");
    formData.append("deskripsi", form.deskripsi || "");
    formData.append("bussinesname", form.bussinesname || "");
    formData.append("version", form.version || "");
    formData.append("theme", form.theme || "maroon");
    formData.append("font_family", form.font_family || "inter");
    formData.append("linkfb", form.linkfb || "");
    formData.append("linkinstagram", form.linkinstagram || "");
    formData.append("linkyoutube", form.linkyoutube || "");
    formData.append("linkemail", form.linkemail || "");
    formData.append("linktiktok", form.linktiktok || "");
    formData.append("linkweb", form.linkweb || "");
    formData.append("_method", "PUT");
    if (form.logo instanceof File) formData.append("logo", form.logo);

    router.post(route("aplikasi.update", form.id), formData, {
      preserveScroll: true,
      onSuccess: () => {
        form.logo = null;
        Swal.fire({ title: "Berhasil!", text: "Pengaturan aplikasi diperbarui.", icon: "success", timer: 1600, showConfirmButton: false });
      },
      onError: () => {
        Swal.fire({ title: "Gagal!", text: "Periksa kembali input.", icon: "error" });
      },
    });
  } else {
    form.post(route("aplikasi.store"), {
      preserveScroll: true,
      forceFormData: true,
      onSuccess: () => {
        Swal.fire({ title: "Berhasil!", text: "Pengaturan aplikasi disimpan.", icon: "success", timer: 1600, showConfirmButton: false });
      },
      onError: () => {
        Swal.fire({ title: "Gagal!", text: "Periksa kembali input.", icon: "error" });
      },
    });
  }
};
</script>
